import { InvoiceRepository } from "../repositories/InvoiceRepository";
import { InvoicesResultEntity } from "../entities/InvoiceListItemEntity";

export class GetInvoicesForCustomerUseCase {
  constructor(private repository: InvoiceRepository) {}

  async execute(
    customerZohoId: string,
    limit?: number,
    offset?: number,
    search?: string
  ): Promise<InvoicesResultEntity> {
    // Validate Zoho customer ID
    if (!customerZohoId || customerZohoId.trim() === "") {
      throw new Error("Customer ID is required");
    }

    // Validate pagination parameters
    if (limit !== undefined && (limit < 1 || limit > 100)) {
      throw new Error("Limit must be between 1 and 100");
    }

    if (offset !== undefined && offset < 0) {
      throw new Error("Offset must be 0 or greater");
    }

    // Execute repository call
    return await this.repository.getInvoicesForCustomer(
      customerZohoId.trim(),
      limit,
      offset,
      search?.trim()
    );
  }
}
